// eslint-disable-next-line no-restricted-imports
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { logger } from 'framework/utils/logging';
import Components from './index';
const ComponentLoader = ({ loaderProps })=>{
    if (!loaderProps) {
        return null;
    }
    if (typeof loaderProps === 'string') {
        return loaderProps;
    }
    const { __component, props: componentProps } = loaderProps;
    if (!__component) {
        return null;
    }
    const Component = Components[__component];
    if (!Component) {
        // todo: replace with logger, .error crashes on ssr
        logger.error(`${__component} component does not exist. 
      Loader props: ${JSON.stringify(loaderProps)}`);
        return null;
    }
    if (!componentProps) {
        return /*#__PURE__*/ _jsx(Component, {});
    }
    const props = {};
    for(const key in componentProps){
        // eslint-disable-next-line no-prototype-builtins
        if (componentProps.hasOwnProperty(key)) {
            const componentProp = componentProps[key];
            const isObjectProp = componentProp && typeof componentProp === 'object';
            const hasChildComponent = isObjectProp && typeof componentProp.__component !== 'undefined';
            const hasChildComponentArray = Array.isArray(componentProp) && componentProp.find((c)=>c !== null && typeof c.__component !== 'undefined');
            props[key] = hasChildComponent ? /*#__PURE__*/ _jsx(ComponentLoader, {
                loaderProps: componentProp
            }) : hasChildComponentArray ? componentProp.filter(Boolean).map((prop, _index)=>/*#__PURE__*/ _jsx(ComponentLoader, {
                    loaderProps: prop
                }, _index)) : componentProp;
        }
    }
    return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
};
const TemplateLoader = ({ loaderProps })=>{
    const propsArray = Array.isArray(loaderProps) ? loaderProps : [
        loaderProps
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: propsArray.map((props, index)=>/*#__PURE__*/ _jsx(ComponentLoader, {
                loaderProps: props
            }, index))
    });
};
export default TemplateLoader;
